import React from "react";
import { motion } from "framer-motion";

const WhyChooseUs = () => {
  const cards = [
    {
      title: "Services",
      text: "Explore our full range of services, including installation, maintenance, and after-sales support — ensuring your equipment performs flawlessly.",
    },
    {
      title: "Industries Served",
      text: "We proudly serve educational institutions, research labs, healthcare facilities, and industrial clients with precision-engineered solutions.",
    },
    {
      title: "Resources",
      text: "Gain access to product catalogs, guides, and documentation to make informed decisions about your scientific needs.",
    },
    {
      title: "News & Updates",
      text: "Stay updated with our latest innovations, events, and product launches across Pakistan’s scientific community.",
    },
  ];

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="relative w-full bg-white py-24 overflow-hidden">
      {/* Main Content */}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        {/* Heading Section */}
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#1E1E1E]">
            WHY <span className="text-[#B80000]">CHOOSE US?</span>
          </h2>
          <p className="mt-4 text-lg text-gray-700 max-w-2xl mx-auto">
            Discover what makes{" "}
            <strong className="text-[#B80000]">Torshia Traders Pvt. Ltd.</strong>{" "}
            the preferred partner in chemicals, labware, and scientific equipment
            across Pakistan.
          </p>
        </motion.div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Section */}
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <p className="text-sm uppercase tracking-wide text-[#B80000] mb-2">
              Your Trusted Scientific Partner
            </p>
            <h3 className="text-4xl md:text-5xl font-bold text-[#1E1E1E] leading-tight mb-4">
              Torshia Traders <span className="text-[#B80000]">Pvt. Ltd.</span>
            </h3>
            <div className="w-24 h-[3px] bg-[#B80000] mb-8"></div>
            <p className="text-gray-700 leading-relaxed mb-10 text-lg">
              At <strong>Torshia Traders</strong>, we redefine reliability and
              innovation. From laboratory essentials to advanced equipment, our
              products meet the highest standards of precision and performance —
              empowering professionals to achieve excellence.
            </p>

            <button
              onClick={handleScrollToTop}
              className="bg-[#B80000] text-white font-semibold px-8 py-3 rounded-lg shadow-md hover:bg-[#8B0000] hover:shadow-lg transition-all duration-300"
            >
              Read More
            </button>
          </motion.div>

          {/* Right Cards */}
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="grid grid-cols-1 sm:grid-cols-2 gap-8"
          >
            {cards.map((card, index) => (
              <motion.div
                key={index}
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0 10px 30px rgba(184,0,0,0.15)",
                }}
                transition={{ type: "spring", stiffness: 200 }}
                className="bg-[#F9F9F9] p-6 rounded-2xl shadow-md hover:shadow-lg border border-gray-100 cursor-pointer"
              >
                <h4 className="text-xl font-semibold text-[#B80000] mb-2">
                  {card.title}
                </h4>
                <p className="text-gray-700 text-sm leading-relaxed">
                  {card.text}
                </p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
